import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, FormattedMessage } from 'react-intl';
import messages from './messages';
import { getYearFromTimestamp } from '../../../utils/timestamp';
import './styles.css';

class Contact extends React.PureComponent {
  static propTypes = {
    admissionsContact: PropTypes.object,
    lastUpdated: PropTypes.string,
  };

  render() {
    const { schoolName, attn, phone, fax, financialAid, email } =
      this.props.admissionsContact || {};
    const lastUpdatedYear = getYearFromTimestamp(this.props.lastUpdated);
    return (
      <div className="admissions-contact-section" data-cy="admissions-contact-section">
        <div className="info-container">
          <div className="section" data-cy="admissions-contact-hint">
            <FormattedMessage values={{ schoolName }} {...messages.hint} />
          </div>
          <div className="section">
            <div className="title" data-cy="admissions-contact-title">
              <FormattedMessage {...messages.title} />
            </div>
            <div className="info" data-cy="admissions-contact-attn">
              <FormattedMessage values={{ attn }} {...messages.attn} />
            </div>
            <div className="info" data-cy="admissions-contact-phone">
              <FormattedMessage values={{ phone }} {...messages.phone} />
            </div>
            <div className="info" data-cy="admissions-contact-fax">
              <FormattedMessage values={{ fax }} {...messages.fax} />
            </div>
            <div className="info" data-cy="admissions-contact-aid">
              <FormattedMessage values={{ financialAid }} {...messages.financial_aid} />
            </div>
            <div className="info" data-cy="admissions-contact-email">
              <FormattedMessage values={{ email }} {...messages.email} />
            </div>
          </div>
        </div>
        <div className="footer-container" data-cy="admissions-contact-footer">
          <FormattedMessage values={{ lastUpdatedYear }} {...messages.footer} />
        </div>
      </div>
    );
  }
}

export default injectIntl(Contact);
